import CustomScrollbar from 'components/CustomScrollbar';
import styled from 'styled-components';
import { mediaBreakpointUp } from 'styles/grid';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TrackingTimelineContainer = styled.div`
  padding: 20px 40px 0 40px;
`;

export const HorizontalLine = styled.hr`
  margin: 16px 40px 0px 40px;
  border: 1px solid rgba(0, 0, 0, 0.38);
`;

export const MainInfoContainer = styled(CustomScrollbar)`
  overflow: auto;
  flex: 1;
`;

export const ProgressIndicatorContainer = styled.div`
  ${mediaBreakpointUp.md} {
    padding: 0 32px;
  }
`;
